import CalculatorProjectModuleGeometry from './module.geometry';
class CalculatorProjectGeometry {
    project;
    constructor(project) {
        this.project = project;
    }
    getAll() {
        const modules = this.project.getModules();
        return modules.map(moduleData => new CalculatorProjectModuleGeometry(this.project, moduleData));
    }
}
export default CalculatorProjectGeometry;
